// NPM Imports
import React, { memo } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TitleBar = memo(({ iconName, title, subTitle }) => (
  <div
    data-test={`titlebar-wrapper-${title.replace(/ /g, "").toLowerCase()}`}
    className="titlebar-wrapper">
    <span
      className="titlebar-icon"
      data-test={`titlebar-icon-${title.replace(/ /g, "").toLowerCase()}`}>
      <FontAwesomeIcon icon={["far", iconName]} />{" "}
    </span>
    <span
      data-test={`titlebar-topbar-text-${title
        .replace(/ /g, "")
        .toLowerCase()}`}
      className="titlebar-topbar-text">
      <span
        className="titlebar-topbar-title"
        data-test={`titlebar-topbar-title-${title
          .replace(/ /g, "")
          .toLowerCase()}`}>
        {title}
      </span>
      <span
        data-test={`titlebar-topbar-subtitle-${title
          .replace(/ /g, "")
          .toLowerCase()}`}
        className="titlebar-topbar-subtitle">
        {subTitle}
      </span>
    </span>
  </div>
));
TitleBar.defaultProps = {};

TitleBar.propTypes = {
  iconName: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default TitleBar;



// WEBPACK FOOTER //
// ./src/components/TitleBar/index.js